import { render, staticRenderFns } from "./Propio2.vue?vue&type=template&id=090c8d94"
import script from "./Propio2.vue?vue&type=script&lang=js"
export * from "./Propio2.vue?vue&type=script&lang=js"
import style0 from "./Propio2.vue?vue&type=style&index=0&id=090c8d94&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports